import CheckboxWidget from "./CheckboxWidget/CheckboxWidget";
import CheckboxesWidget from "./CheckboxesWidget/CheckboxesWidget";
import PasswordWidget from "./PasswordWidget/PasswordWidget";
import RadioWidget from "./RadioWidget/RadioWidget";
import RangeWidget from "./RangeWidget/RangeWidget";
import SelectWidget from "./SelectWidget/SelectWidget";
import TextareaWidget from "./TextareaWidget/TextareaWidget";
import TextWidget from "./TextWidget/TextWidget";
import UpDownWidget from "./UpDownWidget/UpDownWidget";
import HeaderWidget from "./HeaderWidget/HeaderWidget";
import ButtonGroup from "./ButtonGroup/ButtonGroup";

import FileUploadWidget from "./FileUploadWidget/FileUploadWidget";
import ImageUploadWidget from "./ImageUploadWidget/ImageUploadWidget";
import SignatureWidget from "./SignatureWidget/SignatureWidget";
import PersonPickerWidget from "./PersonPickerWidget/PersonPickerWidget";
import MapLocationWidget from "./MapLocationWidget";
import RelatedPermitWidget from "./RelatedPermitWidget";
import AreaSelect from "./AreaSelect";
import DateTimeWidget from "./DateTimeWidget";
import DateRangeWidget from "./DateRangeWidget";
import PermitValidityWidget from "./PermitValidityWidget";


const Widgets = {
  CheckboxWidget,
  CheckboxesWidget,
  PasswordWidget,
  RadioWidget,
  RangeWidget,
  SelectWidget,
  TextareaWidget,
  TextWidget,
  UpDownWidget,
  "header": HeaderWidget,
  "buttonGroup": ButtonGroup,

  "fileUpload": FileUploadWidget,
  "imageUpload": ImageUploadWidget,
  "signature": SignatureWidget,

  "personPicker": PersonPickerWidget,
  "mapLocation": MapLocationWidget,
  "areaSelect": AreaSelect,
  "dateTime": DateTimeWidget,
  "dateRange": DateRangeWidget,


  "relatedPermit": RelatedPermitWidget,
  "permitValidity": PermitValidityWidget,

};

export default Widgets;